import {
  Inbox,
  Hammer,
  Package,
  Users,
  Banknote,
  BarChart3,
  Zap,
  Puzzle,
  Sparkles,
  ShieldAlert,
  LayoutDashboard,
  Warehouse,
  MessageSquare,
  HandHelping,
  UserCog,
  Wallet,
  Receipt,
  Briefcase,
  TrendingUp,
  FileText,
  Target,
  Mail,
} from 'lucide-react';

/**
 * Maps lucide-react icon names (as sent by the plugin store API)
 * to actual icon components. Keep in sync with backend plugin catalog
 * at products/utils/plugin_catalog.py.
 */
export const PLUGIN_ICON_MAP = {
  Inbox,
  Hammer,
  Package,
  Users,
  Banknote,
  BarChart3,
  Zap,
  Puzzle,
  Sparkles,
  ShieldAlert,
  LayoutDashboard,
  Warehouse,
  MessageSquare,
  HandHelping,
  UserCog,
  Wallet,
  Receipt,
  Briefcase,
  TrendingUp,
  FileText,
  Target,
  Mail,
};

export const getPluginIcon = (name) =>
  (name && PLUGIN_ICON_MAP[name]) || Puzzle;

export default PLUGIN_ICON_MAP;
